import validate from "/usr/src/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import i18n_45locale_45global from "/usr/src/app/middleware/i18n-locale.global.ts";
import legacy_45resale_45redirect_45global from "/usr/src/app/middleware/legacy-resale-redirect.global.ts";
import training_45root_45redirect_45global from "/usr/src/app/middleware/training-root-redirect.global.ts";
import uae_45no_45pricing_45global from "/usr/src/app/middleware/uae-no-pricing.global.ts";
import manifest_45route_45rule from "/usr/src/app/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  i18n_45locale_45global,
  legacy_45resale_45redirect_45global,
  training_45root_45redirect_45global,
  uae_45no_45pricing_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "admin-login-redirect": () => import("/usr/src/app/middleware/admin-login-redirect.ts"),
  "am-login-redirect": () => import("/usr/src/app/middleware/am-login-redirect.ts"),
  "client-mode-guard": () => import("/usr/src/app/middleware/client-mode-guard.ts"),
  "is-account-manager": () => import("/usr/src/app/middleware/is-account-manager.ts"),
  "is-admin": () => import("/usr/src/app/middleware/is-admin.ts"),
  "is-agent": () => import("/usr/src/app/middleware/is-agent.ts"),
  "is-auth-route": () => import("/usr/src/app/middleware/is-auth-route.ts"),
  "is-auth": () => import("/usr/src/app/middleware/is-auth.ts"),
  "is-developer-rep": () => import("/usr/src/app/middleware/is-developer-rep.ts"),
  "is-eval-auth": () => import("/usr/src/app/middleware/is-eval-auth.ts"),
  "is-verified": () => import("/usr/src/app/middleware/is-verified.ts"),
  "unauth-vault-prompt": () => import("/usr/src/app/middleware/unauth-vault-prompt.ts")
}